export default {
  state: {
    loading: false,
    providers: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/ProvidersStore.js